export const quizTypes = {
  onLogin: 'quizOnLogin',
  onHold: 'quizOnHold',
  onCent: 'quizOnCent'
}